import React, { useState } from 'react';

import { Alert, Box, Button, Grid, Stack, Typography } from '@mui/material';
import KpiComponent from '@/components/Base/KpiComponent';
import {
  useConsolidationSummaryInadimplenciaEvolucao,
} from '@/features/dashboard/api/getConsolidationSummaryInadimplenciaEvolucao';
import CurrencyFormat from '@/utils/CurrencyFormat.ts';
import dayjs from 'dayjs';
import ImportCountDefault from '@/components/Base/ImportCountDefault';
import { useNavigate } from 'react-router-dom';
import ScoreInadimplenciaCategoriaEvolucao from '@/features/dashboard/ScoreInadimplenciaCategoriaEvolucao';
import LoadingSummary from '@/features/dashboard/components/LoadingSummary';
import PeriodFilterYearMonthy from '@/components/Base/PeriodFilterYearMonthy';
import { TitlePages } from '@/components/Base/TitlePage';
import ScoreInadimplenciaAcumulo from '@/features/dashboard/ScoreInadimplenciaAcumulo';
import ScoreInadimplenciaEvolucao from '@/features/dashboard/ScoreInadimplenciaEvolucao';
import LoadingChart from '@/features/dashboard/components/LoadingChart';
import PeriodFilterDash from '@/components/Base/PeriodFilterDash';

export const InadimplenciaEvolucao = () => {
  const startDate = dayjs().startOf('year').format('YYYY-MM-DD');
  const endDate = dayjs().endOf('month').format('YYYY-MM-DD');

  const [open, setOpen] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(startDate);
  const [selectedEndDate, setSelectedEndDate] = useState(endDate);
  const [selectedYear, setSelectedYear] = useState(dayjs().year());
  const [selectedMonth, setSelectedMonth] = useState(null);

  
  const filters = {
    ...(selectedYear && { year: selectedYear }),
    ...(selectedMonth && { month: selectedMonth }),
  };


  const { data: summary, isError, refetch, isFetching, isFetched } = useConsolidationSummaryInadimplenciaEvolucao(filters);
  const [listYears, setListYears] = useState([]);

  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <ImportCountDefault open={open} handleClose={handleClose} />

      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <TitlePages title={'Evolução de inadimplência'}/>

        <Stack flexDirection={'row'} gap={'20px'}>
          <Button
            sx={{
              p: '0 15px',
              borderRadius: '24px',
              fontSize: '14px',
              height: '30px',
              color: '#fff !important',
              weight: '700',
              background: '#15AB51',
              fontWeight: 700,
              textTransform: 'capitalize',
            }}
            variant="contained"
            // onClick={() => setConfigAdvanced(true)}/inadimplencia-configuracoes-avancadas-visao
            onClick={() => navigate('/inadimplencia-configuracoes-avancadas-evolucao')}
          >
            Configurações avançadas
          </Button>
        </Stack>
      </Stack>

      <Box
        padding={'15px'}
        sx={{
          border: '1px solid rgba(176, 176, 176, 1)',
          background: '#fff',
          borderRadius: '14px',
        }}
      >
        {isError && (
          <Alert
            severity="error"
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  refetch();
                }}
              >
                Atualizar
              </Button>
            }
          >
            Não foi possível carregar as informações!
          </Alert>
        )}

        {summary && isFetched && (
          <Stack flexDirection={'row'} gap={'8px'}>
            <Stack
              flexDirection="row"
              maxWidth="100%"
              gap="8px"
              style={{
                overflowX: 'auto',
                scrollBehavior: 'smooth',
                scrollbarWidth: 'thin',
                scrollbarColor: '#888 #f1f1f1',
              }}
            >
              <KpiComponent title={'Total de inadimplência atual'} 
                value={`${summary.current_inadimplance || '0'}%`}
                tooltipText={'Relaciona Total a receber no ano e Total de boletos atrasados no ano corrente.'}
                style={{ minWidth: '160px' }}
              />
              <KpiComponent
                title={'Total de inadimplência acumulada'}
                value={`${summary.current_month_inadimplance || '0'}%`}
                tooltipText={
                  'Compara o valor acumulado de todos os boletos emitidos até hoje (incluindo anos anteriores) com o valor total de boletos ainda em aberto no mesmo período.'
                }
                style={{ minWidth: '160px' }}
              />
              <KpiComponent
                title={'Total de inadimplência do mês'}
                value={CurrencyFormat.format(summary.total_inadimplance_month)}
                tooltipText={
                  'Valor acumulado de todos os boletos inadimplentes no mês atual.'
                }
                style={{ minWidth: '180px' }}
              />
              <KpiComponent
                title={'Total de inadimplência acumulada'}
                value={CurrencyFormat.format(summary.total_inadimplance_accumulated)}
                tooltipText={
                  'Valor acumulado de todos os boletos inadimplentes no ano atual.'
                }
                style={{ minWidth: '160px' }}
              />
            </Stack>
          </Stack>
        )}

        <LoadingChart loading={isFetching} />
        
        {isFetched && <PeriodFilterDash 
          showPeriodFilter={false}
          startDate={selectedStartDate}
          endDate={selectedEndDate}
          onStartDateChange={setSelectedStartDate}
          onEndDateChange={setSelectedEndDate}
          refetchDashboard={() => {}}
          listYears={listYears}
          setSelectedYear={setSelectedYear}
          setSelectedMonth={setSelectedMonth}
          selectedYear={selectedYear}
          selectedMonth={selectedMonth}
        />}

        <Grid mt={'10px'} container spacing={2}>
          <Grid item xs={12}>
            <ScoreInadimplenciaEvolucao
              year={parseInt(String(selectedYear))}
              month={selectedMonth} />
          </Grid>
        </Grid>

        {isFetching && !summary && !summary?.current_inadimplance && <LoadingSummary />}

        <Grid mt={'10px'} container spacing={2}>
          <Grid item xs={12}>
            <ScoreInadimplenciaCategoriaEvolucao
              year={parseInt(String(selectedYear))}
              month={selectedMonth} setListYears={setListYears}
            />
          </Grid>
        </Grid>

        <Grid mt={'10px'} container spacing={2}>
          <Grid item xs={12}>
            <ScoreInadimplenciaAcumulo
              year={parseInt(String(selectedYear))}
              month={selectedMonth} />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
